export default __webpack_public_path__ + "static/media/Photo 1 - BR - murs pierre.6b6f4263.jpg";